import { LanguageAvailable } from '@shared/services/language/models';
import { ca, es, fr, Locale, nlBE } from 'date-fns/locale';

const LOCALE_MAP: Record<LanguageAvailable, Locale> = {
  'fr-FR': fr,
  'es-ES': es,
  'ca-ES': ca,
  'fr-BE': fr,
  'nl-BE': nlBE,
};
export const getLocaleDateFns = (locale: LanguageAvailable) => LOCALE_MAP[locale] ?? fr;
